import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { UserState } from '../../states';
import { waitForUserLoaded } from './wait-for-user-loaded.util';

export const canActivateTasks: CanActivateFn = async (): Promise<boolean | UrlTree> => {
    const store = inject(Store);
    const router = inject(Router);

    await waitForUserLoaded(store);

    return store.selectSnapshot(UserState.isTaskOwner) ? true : router.parseUrl('/requests');
};

export const canActivateRequests: CanActivateFn = async (): Promise<boolean | UrlTree> => {
    const store = inject(Store);
    const router = inject(Router);

    await waitForUserLoaded(store);

    return store.selectSnapshot(UserState.isTaskOwner) ? router.parseUrl('/tasks') : true;
};
